// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"130dc156","399":"6cf59360","589":"749cce30","897":"f5d7bbce"}[chunkId] + ".chunk.css";
};